import React, { Fragment } from 'react';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Form, List, Popover, Row, Tag } from 'antd';
import get from 'lodash/get';
import moment from 'moment';
import { ProjectDescriptionPanel } from '@gtintel/platform-admin-components';
import { SwitchMuteState } from '@gtintel/platform-api';
import { LoadingSpinner2, SwitchButton, TagsGroupList, UserPill } from '@gtintel/platform-atoms';
import { COOKIE_NAMES, DEFAULT_DATE_PICKER_TIME_FORMAT, DEFAULT_SHOW_TIME_FORMAT, DEFAULT_TIME_FORMAT, PROJECT_TYPE, TAG_COLORS } from '@gtintel/platform-constants';
import { PartnerState, ProjectSteps } from '@gtintel/platform-molecules';
import { UserRole } from '@gtintel/platform-types';
import { getSessionStorageItem } from '@gtintel/platform-utils';
import { ClientPrice } from './ClientPrice';
import { CXLeadContainer, TagTitle, WrapContent } from './styles';
const styles = {
  tenderSection: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#98a9bc',
    marginTop: '24px'
  },
  tenderValue: {
    fontWeight: 700
  }
};
class ProjectDetailContent extends React.Component {
  constructor(props) {
    super(props);
    this.showModal = () => {
      this.setState({
        visible: true
      });
    };
    const {
      project
    } = props;
    this.state = {
      visible: false,
      is_muted: project.client.is_muted || false
    };
  }
  render() {
    const tags = [];
    const {
      typeBatch,
      project
    } = this.props;
    if (this.props.project && !!this.props.project.tags && this.props.project.tags.length !== 0) {
      this.props.project.tags.map(tag => tags.push(<Tag key={tag.id} color={TAG_COLORS[Number(tag.tag_group_code ?? tag.tag_group)]}>
            {tag.name}
          </Tag>));
    } else {
      tags.push('No tags added');
    }
    const rawRequestedCompletionDate = get(this.props, ['project', 'requested_completion_date'], '');
    const requestedCompletionDate = moment(rawRequestedCompletionDate, 'YYYY-MM-DD').isValid() ? moment(rawRequestedCompletionDate, 'YYYY-MM-DD') : moment(rawRequestedCompletionDate);
    const status = get(this.props, ['project', 'status']) || '-';
    const isPendingAnalysis = (this.props.project.project_type.id === 9 || this.props.project.project_type.id === 1) && this.props.project.final_price !== 0;
    const price = get(this.props, ['project', 'final_price']) || '-';
    const netPrice = get(this.props, ['project', 'net_price']) || '-';
    const content = [];
    if (this.props.cateTags && this.props.cateTags.count !== 0 && this.props.cateTags.results !== undefined) {
      this.props.cateTags.results.map(cate => content.push(<TagsGroupList key={cate.id} data={cate} />));
    }
    const userAccount = getSessionStorageItem(COOKIE_NAMES.INFOR_USER);
    if (!userAccount) return null;
    const isAdminUser = Number(userAccount.role) === UserRole.Admin;
    const isAnalyst = Number(userAccount.role) === UserRole.Analyst;
    const handleSwitchMuteButton = async () => {
      this.setState({
        is_muted: !this.state.is_muted
      });
      SwitchMuteState({
        projectId: project.id,
        is_muted: this.state.is_muted
      });
    };
    if (!project) return <LoadingSpinner2 margin="150px" />;
    const priceInfo = isAnalyst ? null : <Form.Item>
        <strong>Price</strong>
        <ClientPrice price={price} netPrice={netPrice} currency={project.currency} isPendingAnalysis={isPendingAnalysis} />
      </Form.Item>;
    return <div className="project-detail-view">
        {isAdminUser && !userAccount.is_network_partner && <SwitchButton title="Mute notifications" checked={this.state.is_muted} onChange={handleSwitchMuteButton} />}
        {typeBatch === PROJECT_TYPE.BATCH && <Fragment>
            <div className="tender" style={styles.tenderSection}>
              <p className="tenderID">
                Project ID:{' '}
                <span style={styles.tenderValue}>{project.id ?? '-'}</span>
              </p>
              <p className="tenderYear">
                Created date:{' '}
                <span style={styles.tenderValue}>
                  {project.created_date ? moment(project.created_date, DEFAULT_DATE_PICKER_TIME_FORMAT).format(DEFAULT_SHOW_TIME_FORMAT) : ''}
                </span>
              </p>
            </div>
            <Form.Item label="Project Type" className="form-item-margin">
              <div className="content-text d-block">
                <b>Batch Project</b>
              </div>
            </Form.Item>{' '}
          </Fragment>}
        <Form.Item>
          <div className="content-text d-block">
            <strong>Brief Description</strong>
            <ProjectDescriptionPanel project={project} />
          </div>
          {!userAccount.is_network_partner && <WrapContent>
              <strong>Additional Info (Visible only to GTI):</strong>{' '}
              {project?.additional_info}
            </WrapContent>}
        </Form.Item>

        {this.props.project.cx_lead && <CXLeadContainer>
            <h5>CX Lead</h5>
            <div>
              <UserPill user={this.props.project.cx_lead} showName background="#f6fafb" empty_message="No CX Lead set" />
            </div>
          </CXLeadContainer>}

        <Form.Item label={<>
              <TagTitle>Tags</TagTitle> &nbsp;
              <Popover content={<List bordered={false} className="listGrouptags">
                    {content}
                  </List>} placement="bottomRight">
                <FontAwesomeIcon icon={faInfoCircle} size="lg" />
              </Popover>
            </>} className="form-item-margin">
          <div className="tags">{tags}</div>
        </Form.Item>
        <Row>
          <Col md={12}>
            <Form.Item>
              <strong>Requested Completion Date</strong>
              <p className="content-tagtitle">
                {requestedCompletionDate.isValid() ? moment(requestedCompletionDate, 'YYYY-MM-DD').format(DEFAULT_TIME_FORMAT) : '-'}
              </p>
            </Form.Item>
          </Col>
          <Col md={12}>{priceInfo}</Col>
        </Row>
        <Form.Item>
          <strong>Status</strong>
          <ProjectSteps step={Number(status)} typebatch={typeBatch} />
        </Form.Item>
        <PartnerState project={this.props.project} />
      </div>;
  }
}
export default ProjectDetailContent;